import { action, makeAutoObservable, observable } from "mobx";

import { BalanceTransactionRequest, BalanceUpdateData, TicketAccepted, UserWallet } from "../models";
import { BalanceOperationTabAction, IconTypes, PrintTypes, TransactionStatus } from "../enums";
import { setTranslationValues } from "../helpers";
import { Toaster } from "../view/containers";
import { RootStore } from "./index";
import { T } from "../constants";
import { ws } from "../api";

export class LiveUpdateStore {
  private rootStore: RootStore;

  public reconnecting: boolean = false;
  public connectionLost: boolean = false;

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this, {
      reconnecting: observable,
      connectionLost: observable,
      setReconnecting: action,
      setConnectionLost: action,
    });
  }

  public setReconnecting(value: boolean): void {
    this.reconnecting = value;
  }

  public setConnectionLost(value: boolean): void {
    this.connectionLost = value;
  }

  public async init(): Promise<void> {
    await ws.init();
    this.listenEvents();
  }

  private handleWalletUpdate(data: UserWallet): void {
    this.rootStore.userStore.updateWallet(data);
  }

  private handleTicketAccepted(data: TicketAccepted): void {
    this.rootStore.ticketsStore.setTicketPrintData({
      type: PrintTypes.Bet,
      data,
    });
  }

  private handleBalanceRequest(data: BalanceTransactionRequest): void {
    const { balanceRequestList } = this.rootStore.transactionsStore;
    const trKey = data.type === BalanceOperationTabAction.GetMoneyFromOrCashOut ? T.BALANCE_REQUEST_GET_MESSAGE : T.BALANCE_REQUEST_SEND_MESSAGE;
    this.rootStore.transactionsStore.setBalanceRequestList(balanceRequestList.fetched({count: balanceRequestList.data.items.length + 1, items: [data,...balanceRequestList.data.items]}));
    Toaster.info({message: (
        setTranslationValues(this.rootStore.translationsStore.translate(trKey) , {
          amount: `${data.amount} ${this.rootStore.authStore.currencyCode}`,
          name: data.name,
        })
      ),
      icon: IconTypes.Notification,
      onClick: () => this.rootStore.modalStore.setBalanceRequestModal({ open: true, data: data }),
    });
  }

  private handleBalanceRequestApproveOrReject(data: BalanceUpdateData): void {
    const { status } = data;
    if (+status === +TransactionStatus.Approved) {
      Toaster.success({
        message: T.REQUEST_SUCCESS_MESSAGE,
      });
    } else {
      Toaster.error({
        message: T.REQUEST_REJECT_MESSAGE,
      });
    }
  }

  private handleClose(): void {
    this.setConnectionLost(true);
  }

  private listenEvents(): void {
    ws.onClose(this.handleClose.bind(this));
    ws.onWalletUpdate(this.handleWalletUpdate.bind(this));
    ws.onTicketAccepted(this.handleTicketAccepted.bind(this));
    ws.onBalanceRequest(this.handleBalanceRequest.bind(this));
    ws.onBalanceRequestApproveOrReject(this.handleBalanceRequestApproveOrReject.bind(this));
  }
}
